import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OutageNoticeComponent } from 'src/app/outage-notice/outage-notice.component';
import { AppConfigService } from 'src/app/app-config.service';

@Injectable({
  providedIn: 'root'
})

export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router,
    private appConfig: AppConfigService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userToken = sessionStorage.getItem('access_token');
    const config = this.appConfig.getConfig();
    if (req.headers.get('No-Auth') === 'True' || req.url.indexOf('.well-known') > 0 || req.url.indexOf('secureauth') > 0) {
      return next.handle(req.clone());
    }
    if (userToken != null && userToken !== undefined) {
      const clonedreq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + userToken)
          .set('Cache-Control', 'no-cache, no-store').set('Pragma', 'no-cache, no-store')
      });
      return next.handle(clonedreq)
        .pipe(tap(
          (succ: HttpResponse<any>) => {
            if (succ && succ.body) {
              const response = succ.body;
              // outage
              if (response.statusCode === 422) {
                sessionStorage.clear();
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.config = [];
                  this.router.config.push(
                    { path: 'outagenotice', component: OutageNoticeComponent },
                    { path: '', redirectTo: '/outagenotice', pathMatch: 'full' },
                    { path: '**', redirectTo: '/outagenotice', pathMatch: 'full' }
                  );
                  window.location.reload();
                  this.router.navigate(['/outagenotice']);
                });
              }
            }
          },
          err => {
            if (err instanceof HttpErrorResponse) {
              switch (err.status) {
                // service error
                case 400:
                  this.router.navigate(['/serviceerror']);
                  break;
                // forbidden
                case 401:
                  this.router.navigate(['/forbidden'], { queryParams: { error: 401 } });
                  break;
                // unauthorized
                case 403:
                  this.router.navigateByUrl('/forbidden');
                  break;
              }
            }
          }
        ));
    } else {
      console.log('access token missing, redirecting to error page from auth interceptor.');
      this.router.navigate(['/forbidden'], { queryParams: { usererror: true } });
    }
  }
}
